import { useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(2)
  },
  header: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    marginLeft: theme.spacing(-3),
    marginRight: 5,
    transition: "transform .2s",
    cursor: "pointer"
  },
  collapsed: {
    transform: "rotate(-90deg)"
  },
  content: {}
}));

const Collapser = ({ title, className, style, children }) => {
  const classes = useStyles();
  const [show, setShow] = useState(true);
  const hasChildren = !!children;

  const onClick = () => {
    setShow(prev => !prev);
  };

  return (
    <div className={clsx(classes.root, className)} style={style}>
      <div className={classes.header}>
        {hasChildren && (
          <ArrowDropDown
            className={clsx(classes.icon, !show && classes.collapsed)}
            onClick={onClick}
          />
        )}
        {title}
      </div>
      {hasChildren && (
        <Collapse in={show}>
          <div className={classes.content}>{children}</div>
        </Collapse>
      )}
    </div>
  );
};

export default Collapser;
